export const REPORT_STATE_SELECTOR = "reportGeoAffiliates";
export const REPORT_COLUMNS_KEY =
  "[REPORT ==> affiliates_geo] Visible columns is:";
export const REPORT_DATE_KEY = "[REPORT ==> affiliates_geo] Date range is: ";
